import { ChevronDown } from 'lucide-react';

import { Button } from '@g17eco/ui-modern/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@g17eco/ui-modern/components/ui/dropdown-menu';
import { cn } from '@g17eco/ui-modern/lib/utils';

export interface FilterSelectOption {
  value: string;
  label: string;
}

interface FilterSelectProps {
  value: string;
  options: FilterSelectOption[];
  onSelect: (next: string) => void;
  triggerClassName?: string;
}

export const FilterSelect = ({ value, options, onSelect, triggerClassName }: FilterSelectProps) => {
  const selectedLabel = options.find((o) => o.value === value)?.label ?? options[0]?.label ?? '';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant='outline' size='xs' className={cn('tw:min-w-0 tw:justify-between tw:gap-2', triggerClassName)}>
          <span className='tw:truncate'>{selectedLabel}</span>
          <ChevronDown className='tw:size-3.5 tw:shrink-0' />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='start' className='tw:min-w-[var(--radix-dropdown-menu-trigger-width)]'>
        {options.map((opt) => (
          <DropdownMenuItem
            key={opt.value === '' ? '__all__' : opt.value}
            onClick={() => onSelect(opt.value)}
            className={cn(opt.value === value && 'tw:font-semibold tw:text-emerald-600')}
          >
            {opt.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
